// extracted by mini-css-extract-plugin
export var pageFade = "PageFade-module--pageFade--579af";
export var pageFadeIn = "PageFade-module--pageFadeIn--19c69";